import HowToRegIcon from '@mui/icons-material/HowToReg';
import PersonAddAltSharpIcon from '@mui/icons-material/PersonAddAltSharp';
import { Box, Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { capitalCase } from 'change-case';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Account from './integratedAccounts';
import NewIntegrationComponent from './newIntegration.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useTranslation } from 'react-i18next';

const IntegrationComponent = () => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentTab, setCurrentTab] = useState('New Integration');
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();

  const ACCOUNT_TABS = [
    {
      value: 'New Integration',
      label: `${translate('integration.new_integration')}`,
      icon: <PersonAddAltSharpIcon sx={{ marginRight: '10px' }} />,
      component: <NewIntegrationComponent />,
    },
    {
      value: 'Integrated Accounts',
      label: `${translate('integration.integrated_accounts')}`,
      icon: <HowToRegIcon sx={{ marginRight: '10px' }} />,
      component: <Account isShowOfferBanner={isShowOfferBanner}/>,
    },
  ];
  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.integration')}</title>
      </Helmet>
      <Box>
        <Tabs
          value={currentTab}
          scrollButtons="auto"
          variant="scrollable"
          sx={{ gap: '0.5rem', minHeight: '37px', mt: '0.5rem' }}
          allowScrollButtonsMobile
          onChange={(e, value) => setCurrentTab(value)}
        >
          {ACCOUNT_TABS.map((tab) => {
            return (
              <Tab
                sx={{
                  flexDirection: 'row',
                  gap: '0.25rem',
                  padding: 0,
                  minHeight: '10px',
                  mr: '0.75rem',
                  fontWeight: 600,
                }}
                disableRipple
                key={tab.value}
                label={!isMobile && tab.label}
                icon={tab.icon}
                value={tab.value}
              />
            );
          })}
        </Tabs>
      </Box>
      {ACCOUNT_TABS.map((tab) => {
        const isMatched = tab.value === currentTab;
        return isMatched && <Box key={tab.value}>{tab.component}</Box>;
      })}
    </>
  );
};
export default IntegrationComponent;
